/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { RecordCategoryChildEntry, RecordCategoryChildPaging, RecordCategoryEntry } from '../model';
import { BaseApi } from './base.api';
import { buildCollectionParam } from '../../../alfrescoApiClient';
import { throwIfNotDefined } from '../../../assert';
export class RecordCategoriesApi extends BaseApi {
    createRecordCategoryChild(recordCategoryId, nodeBodyCreate, opts) {
        throwIfNotDefined(recordCategoryId, 'recordCategoryId');
        throwIfNotDefined(nodeBodyCreate, 'nodeBodyCreate');
        const pathParams = {
            recordCategoryId
        };
        const queryParams = {
            autoRename: opts === null || opts === void 0 ? void 0 : opts.autoRename,
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.post({
            path: '/record-categories/{recordCategoryId}/children',
            pathParams,
            queryParams,
            bodyParam: nodeBodyCreate,
            returnType: RecordCategoryChildEntry
        });
    }
    deleteRecordCategory(recordCategoryId) {
        throwIfNotDefined(recordCategoryId, 'recordCategoryId');
        const pathParams = {
            recordCategoryId
        };
        return this.delete({
            path: '/record-categories/{recordCategoryId}',
            pathParams
        });
    }
    getRecordCategory(recordCategoryId, opts) {
        throwIfNotDefined(recordCategoryId, 'recordCategoryId');
        const pathParams = {
            recordCategoryId
        };
        const queryParams = {
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            relativePath: opts === null || opts === void 0 ? void 0 : opts.relativePath,
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.get({
            path: '/record-categories/{recordCategoryId}',
            pathParams,
            queryParams,
            returnType: RecordCategoryEntry
        });
    }
    listRecordCategoryChildren(recordCategoryId, opts) {
        throwIfNotDefined(recordCategoryId, 'recordCategoryId');
        const pathParams = {
            recordCategoryId
        };
        const queryParams = {
            skipCount: opts === null || opts === void 0 ? void 0 : opts.skipCount,
            maxItems: opts === null || opts === void 0 ? void 0 : opts.maxItems,
            where: opts === null || opts === void 0 ? void 0 : opts.where,
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            relativePath: opts === null || opts === void 0 ? void 0 : opts.relativePath,
            includeSource: opts === null || opts === void 0 ? void 0 : opts.includeSource,
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.get({
            path: '/record-categories/{recordCategoryId}/children',
            pathParams,
            queryParams,
            returnType: RecordCategoryChildPaging
        });
    }
    updateRecordCategory(recordCategoryId, recordCategoryBodyUpdate, opts) {
        throwIfNotDefined(recordCategoryId, 'recordCategoryId');
        throwIfNotDefined(recordCategoryBodyUpdate, 'recordCategoryBodyUpdate');
        const pathParams = {
            recordCategoryId
        };
        const queryParams = {
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.put({
            path: '/record-categories/{recordCategoryId}',
            pathParams,
            queryParams,
            bodyParam: recordCategoryBodyUpdate,
            returnType: RecordCategoryEntry
        });
    }
}
